function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.625 6.93995H6.275L10.0288 3.33635C10.3489 3.02903 10.5 2.66243 10.5 2.25995C10.5 1.49243 9.83944 0.699951 8.875 0.699951C8.44356 0.699951 8.06737 0.850491 7.75375 1.15235L1.28787 7.35959C1.02137 7.61543 0.75 7.93133 0.75 8.49995C0.75 9.06857 0.976687 9.34235 1.27487 9.62861L7.75375 15.8475C8.06737 16.1494 8.44356 16.2999 8.875 16.2999C9.84025 16.2999 10.5 15.5075 10.5 14.7399C10.5 14.3375 10.3489 13.9709 10.0288 13.6636L6.275 10.0599H18.625C19.522 10.0599 20.25 9.36107 20.25 8.49995C20.25 7.63883 19.522 6.93995 18.625 6.93995Z",
  fill: "#6F62FF"
});

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowLeft.ba218d1c.svg";
export { ForwardRef as ReactComponent };